/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button, DatePicker, Form, Input, Modal, Select, Space, Table, Tabs, Typography, Upload,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { FaBan, FaPencilAlt } from 'react-icons/fa';
import { MdAddCircle } from 'react-icons/md';
import { GrClose } from 'react-icons/gr';
import { ExclamationCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import _, { forEach } from 'lodash';
import 'moment/locale/vi';
import 'moment/locale/en-il';
import styled from 'styled-components';
import { BsFillLightningFill } from 'react-icons/bs';
import * as yup from 'yup';
import moment from 'moment';
import utils from '../common/utils';
import validate from '../validate/image_validate';
import consts from '../consts';
import DisplayControl from './DisplayControl';
import Loadingsvg from './common/Loadingsvg';

const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Text } = Typography;

const PERMISSION_LINK_SCREEN_CAMPAIGN = '/campaign';

const CenterWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 14,
    span: 10,
  },
};

const ALL = '-1';
const ACTIVE = '0';
const IN_ACTIVE = '1';

function Campaign({
  fetchAllCampaign,
  addCampaignAction,
  updateCampaignAction,
  deleteCampaignAction,
  campaign,
}) {
  const [_form] = Form.useForm();
  const [_totalCount, setTotalCount] = useState(0);
  const [_currentPage, setCurrentPage] = useState(1);
  const [_visible, setVisible] = useState(false);
  const [_isAddNew, setIsAddNew] = useState(false);
  const [_loading, setLoading] = useState(false);
  const [_loadingImage, setLoadingImage] = useState(false);
  const [_status, setStatus] = useState(0);
  const [_link, setLink] = useState('');
  const [_panes, setPanes] = useState([
    {
      title: 'VI',
      key: '0',
      closable: false,
    },
    {
      title: 'EN',
      key: '1',
      closable: false,
    },
  ]);
  const [_activeKey, setActiveKey] = useState(_panes[0].key);
  const [_title, setTitle] = useState({
    VI: '',
    EN: '',
  });
  const [_currentTitle, setCurrentTitle] = useState('');
  const [_campaignId, setCampaginId] = useState('');
  const [_shortContent, setShortContent] = useState({
    VI: '',
    EN: '',
  });
  const [_newTabIndex, setNewTabIndex] = useState(2);
  const [_startTime, setStartTime] = useState('');
  const [_endTime, setEndTime] = useState('');
  const [isLoadingSave] = useState(false);
  const [pathImage, setPathImage] = useState('');
  const [errors, setErrors] = useState({});
  const [errorTitle, setErrorTitle] = useState('');
  const titleValidate = {};
  const shortValidate = {};
  const history = useHistory();
  let filter = {
    pos: 0,
    count: consts.DEFAULT_PAGE_SIZE,
    status: ALL,
  };
  // function

  _.forEach(_panes, (pane) => {
    titleValidate[pane.title] = yup.string()
      .required('Vui lòng nhập tiêu đề ')
      .trim();
    shortValidate[pane.title] = yup.string()
      .required('Vui lòng nhập nội dung')
      .trim();
  });

  const schema = yup.object()
    .shape({
      link: yup.string()
        .required('Vui lòng nhập liên kết')
        .trim(),
      pathImage: yup.string()
        .required('Vui lòng tải ảnh lên')
        .trim(),
      title: yup.object(titleValidate),
      shortContent: yup.object(shortValidate),
    });

  const handleChangeImage = (info) => {
    if (info.file.status === 'uploading') {
      setLoadingImage(true);
      return;
    }
    if (info.file.status === 'done') {
      setLoadingImage(false);
    }
  };

  const showModalAdd = () => {
    setVisible(true);
    setIsAddNew(true);
  };

  const showModalDetail = (item) => {
    setVisible(true);
    setIsAddNew(false);
    setStatus(item.status);
    setPathImage(item.path);
    setLink(item.link);
    setTitle(item.title);
    setActiveKey(item.newPanes[0].key);
    setShortContent(item.short_content);
    setCampaginId(item.campaign_id);
    setPanes(item.newPanes);
    setNewTabIndex(item.newPanes.length);
    if (item.start_time === 0) {
      setStartTime(moment().startOf('d').subtract(7, 'd'));
      setEndTime(moment().endOf('d'));
    } else {
      setStartTime(moment.unix(item.start_time));
      setEndTime(moment.unix(item.end_time));
    }
  };

  const updateTotalCount = (totalCount) => {
    setTotalCount(totalCount);
    setLoading(false);
  };

  const removeTitle = (targetKey) => {
    let lastIndex;
    let activeKey1;
    let newArrTitle;
    let newArrShortContent;
    _panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        newArrTitle = _.omit(_title, [pane.title]);
        newArrShortContent = _.omit(_shortContent, [pane.title]);
        lastIndex = i - 1;
      }
    });
    const arr = _panes.filter((pane) => pane.key !== targetKey);
    if (_panes.length && _activeKey === targetKey) {
      if (lastIndex >= 0) {
        activeKey1 = _panes[lastIndex].key;
      } else {
        activeKey1 = _panes[0].key;
      }
    }
    setTitle(newArrTitle);
    setShortContent(newArrShortContent);
    setPanes(arr);
    setActiveKey(activeKey1);
  };

  const fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, isRefresh = false) => {
    setLoading(true);
    if (isRefresh) {
      filter = {
        ...filter,
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      };
      setCurrentPage(1);
    } else {
      filter = {
        ...filter,
        pos,
        count,
      };
    }
    fetchAllCampaign(filter, updateTotalCount);
  };

  const handleCancel = () => {
    setVisible(false);
    setPathImage('');
    setActiveKey(_panes[0].key);
    setPanes([
      {
        title: 'VI',
        key: '0',
        closable: false,
      },
      {
        title: 'EN',
        key: '1',
        closable: false,
      },
    ]);
    setTitle({
      VI: '',
      EN: '',
    });
    setShortContent({
      VI: '',
      EN: '',
    });
    setCurrentTitle('');
    setLink('');
    _form.resetFields();
    setErrors({});
  };

  const handleCampaign = async () => {
    try {
      await schema.validate({
        pathImage,
        title: _title,
        shortContent: _shortContent,
        link: _link,
      }, { abortEarly: false });

      if (_isAddNew) {
        addCampaignAction({
          path: pathImage,
          status: _status,
          title: _title,
          short_content: _shortContent,
          link: _link,
          start_time: moment(_startTime).unix(),
          end_time: moment(_endTime).unix(),
        }, () => {
          handleCancel();
          fetchData();
        });
      } else {
        updateCampaignAction({
          campaign_id: _campaignId,
          path: pathImage,
          status: _status,
          title: _title,
          short_content: _shortContent,
          link: _link,
          start_time: moment(_startTime).unix(),
          end_time: moment(_endTime).unix(),
        }, () => {
          handleCancel();
          fetchData();
        });
      }
    } catch (error) {
      console.log(error, ': error');
      const errs = {};
      forEach(error.inner, (err) => {
        errs[err.path] = err.message;
      });

      setErrors(errs);
    }
  };

  const onSubmit = () => {
    handleCampaign();
  };

  const onFilterStatus = (value) => {
    filter.status = value;
    fetchData();
  };

  const onChangeStatus = (e) => {
    setStatus(e);
  };

  const showModalBan = (camp) => {
    const isActive = `${camp.status}` === ACTIVE;
    const titleConfirm = isActive ? 'Bạn có muốn tạm ngừng chiến dịch ?' : 'Bạn có muốn chiến dịch này hoạt động ?';
    const okText = isActive ? 'Ngừng' : 'Hoạt động';

    confirm({
      title: titleConfirm,
      icon: <ExclamationCircleOutlined />,
      okText,
      okType: 'danger',
      cancelText: 'Không',
      onOk() {
        const campStatus = isActive ? IN_ACTIVE : ACTIVE;
        updateCampaignAction({
          ...camp,
          status: parseInt(campStatus, 10),
        }, fetchData);
      },
    });
  };

  const onDeleteCampaign = (value) => {
    console.log(value, ': value src/component/Campaign.jsx:340');
    confirm({
      title: 'Xóa chiến dịch ?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Xóa',
      okType: 'danger',
      cancelText: 'Không',
      onOk() {
        deleteCampaignAction({ bid: value }, () => fetchData());
      },
    });
  };

  const columnsTable = [
    {
      align: 'center',
      title: 'Id',
      dataIndex: 'campaign_id',
      key: 'campaign_id',
      width: 80,
    },
    {
      align: 'center',
      title: 'Tiêu đề ',
      dataIndex: 'title',
      key: 'title',
      width: 250,
      render: (title) => _.map(title, (item, index) => (
        <div className="d-flex" key={index}>
          <div className="mr-2 ">{`${index}: `}</div>
          <div className="text-left">{item}</div>
        </div>
      )),
    },
    {
      align: 'center',
      title: 'Hình ảnh ',
      dataIndex: 'path',
      width: 100,
      key: 'path',
      render: (value) => <img src={value} width="30px" />,
    },
    {
      align: 'center',
      title: 'Nội dung',
      dataIndex: 'short_content',
      key: 'short_content',
      render: (contents) => _.map(contents, (item, index) => (
        <div className="d-flex" key={index}>
          <div className="mr-2 ">{`${index}: `}</div>
          <div className="text-left line-clamp">{item}</div>
        </div>
      )),
    },
    {
      align: 'center',
      title: 'Đường dẫn',
      dataIndex: 'link',
      key: 'link',
    },
    {
      align: 'center',
      title: 'Thời gian tạo',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => <div>{utils.formatTimeFromUnix(value)}</div>,
    },
    {
      align: 'center',
      title: 'Hành động',
      dataIndex: 'action',
      key: 'action',
      render: (value, camp) => (
        <Space size="middle">
          <FaPencilAlt className="styled-icon" onClick={() => showModalDetail(camp)} />
          <DisplayControl permission_link_screen={PERMISSION_LINK_SCREEN_CAMPAIGN} action="PUT">
            {
              `${camp.status}` === ACTIVE
                ? <FaBan className="styled-icon" onClick={() => showModalBan(camp)} />
                : (
                  <BsFillLightningFill
                    className="styled-icon"
                    onClick={() => showModalBan(camp)}
                  />
)
            }
          </DisplayControl>
          <DisplayControl
            permission_link_screen={consts.AUTH.CAMPAIGN__bID}
            action={consts.CONTROLS.DELETE}
          >
            <GrClose
              className="styled-icon"
              onClick={() => onDeleteCampaign(camp.campaign_id)}
            />
          </DisplayControl>
        </Space>
      ),
    },
  ];

  const uploadButton = (
    <div>
      {_loadingImage ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Tải ảnh</div>
    </div>
  );

  const onChangeTitleContent = (event) => {
    if (event.target) {
      const { target } = event;
      const { value } = target;
      const { name } = target;
      setTitle({
        ..._title,
        [name]: value,
      });
    }
  };

  const onChangeDate = (value) => {
    console.log(value, ': value src/component/Campaign.jsx:455');
    let startTime;
    let endTime;

    if (value !== null) {
      [startTime, endTime] = value;
    } else {
      startTime = '';
      endTime = '';
    }

    setStartTime(startTime);
    setEndTime(endTime);
  };

  const onChangeShortContent = (event) => {
    if (event.target) {
      const { target } = event;
      const { value } = target;
      const { name } = target;
      setShortContent({
        ..._shortContent,
        [name]: value,
      });
    }
  };

  const onEditTitle = (targetKey, action) => (action === 'remove' ? removeTitle(targetKey) : '');

  const addTabs = (e) => {
    setCurrentTitle(e.target.value);
  };

  const addTitle = () => {
    const newArrPanes = _.slice(_panes);
    const a = _.findIndex(newArrPanes, (value) => value.title === _currentTitle);
    if (a === -1) {
      setNewTabIndex(_newTabIndex + 1);
      const activeKey = `${_newTabIndex + 1}`;
      newArrPanes.push({
        title: _currentTitle,
        key: activeKey,
      });
      setPanes(newArrPanes);
      setActiveKey(activeKey);
      setCurrentTitle('');
      setErrorTitle('');
    } else {
      setErrorTitle('Ngôn ngữ đã có');
    }
  };

  const addLang = () => {
    const newArrPanes = _.slice(_panes);
    const a = _.findIndex(newArrPanes, (value, index) => value.title === _currentTitle);
    if (a === -1) {
      setNewTabIndex(_newTabIndex + 1);
      const activeKey = `${_newTabIndex + 1}`;
      newArrPanes.push({
        title: _currentTitle,
        key: activeKey,
        closable: true,
      });
      setActiveKey(activeKey);
      setCurrentTitle('');
      setPanes(newArrPanes);
      setErrorTitle('');
    } else {
      setErrorTitle('Ngôn ngữ đã có');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderFormEdit = () => (
    <Form {...layout} form={_form}>
      <Form.Item label="Trạng thái" hidden>
        <Input name="campaign_id" value={_campaignId} type="text" />
      </Form.Item>
      <Form.Item label="Trạng thái">
        <Select
          value={_status}
          style={{
            width: 120,
            marginRight: 14,
          }}
          onChange={onChangeStatus}
        >
          <Option value={0}>Hoạt Động</Option>
          <Option value={1}>Tạm dừng</Option>
        </Select>
      </Form.Item>
      <Form.Item label="Hình Ảnh" className="mb-large">
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          customRequest={(params) => utils.dumpRequest(params, setPathImage)}
          beforeUpload={validate.beforeUpload}
          onChange={handleChangeImage}
        >
          {pathImage
            ? <img src={pathImage} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
        </Upload>
        <div className="text-left p-abs no-wrap ">
          <Text type="danger">{utils.upperCaseFirst(errors.pathImage || '')}</Text>
        </div>
      </Form.Item>

      <Form.Item label="Thời gian" className="mb-large">
        <RangePicker
          locale={consts.LangDateVi}
          value={[_startTime, _endTime]}
          showTime
          format="DD-MM-YYYY HH:mm"
          // disabledDate={(current) => current && current > moment().endOf('day')}
          onChange={onChangeDate}
        />
      </Form.Item>

      <Form.Item label="Thêm ngôn ngữ">
        <div className="d-flex mb-small">
          <Input type="text" value={_currentTitle} onChange={addTabs} />
          <Button
            onClick={addLang}
            disabled={!_currentTitle}
            className="mr-small"
          >
            Thêm
          </Button>
        </div>
        <div className="text-left p-abs no-wrap ">
          <Text type="danger">{utils.upperCaseFirst(errorTitle || '')}</Text>
        </div>
      </Form.Item>
      <Form.Item name="titleContent" label="Tiêu đề">
        <Tabs
          hideAdd
          onChange={setActiveKey}
          activeKey={_activeKey}
          type="editable-card"
          onEdit={onEditTitle}
          defaultActiveKey="1"
        >
          {_panes.map((pane) => (
            <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
              <div className="mb-medium">
                <Input
                  type="text"
                  name={pane.title}
                  placeholder="Tiêu đề"
                  value={_title[pane.title]}
                  onChange={onChangeTitleContent}
                />
                <div className="text-left p-abs no-wrap">
                  <Text
                    type="danger"
                  >
                    {utils.upperCaseFirst(errors[`title.${pane.title}`] || '')}
                  </Text>
                </div>
              </div>
              <TextArea
                onChange={onChangeShortContent}
                name={pane.title}
                value={_shortContent[pane.title]}
                rows={4}
                placeholder="Nội dung"
              />
              <div className="text-left p-abs no-wrap">
                <Text
                  type="danger"
                >
                  {utils.upperCaseFirst(errors[`shortContent.${pane.title}`] || '')}
                </Text>
              </div>
            </TabPane>
          ))}
        </Tabs>
      </Form.Item>

      <Form.Item label="Đường dẫn">
        <Input onChange={(e) => setLink(e.target.value)} value={_link} name="Link" rows={4} />
        <div className="text-left p-abs no-wrap">
          <Text type="danger">{utils.upperCaseFirst(errors.link || '')}</Text>
        </div>
      </Form.Item>
    </Form>
  );

  const renderFormAdd = () => (
    <Form {...layout} form={_form}>
      <Form.Item name="status" label="Trạng thái">
        <Select
          style={{
            width: 120,
            marginRight: 14,
          }}
          onChange={onChangeStatus}
        >
          <Option value={0}>Hoạt Động</Option>
          <Option value={1}>Tạm dừng</Option>
        </Select>
      </Form.Item>
      <Form.Item label="Hình Ảnh" className="mb-large">
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          customRequest={(params) => utils.dumpRequest(params, setPathImage)}
          beforeUpload={validate.beforeUpload}
          onChange={handleChangeImage}
        >
          {pathImage
            ? (
              <img
                src={pathImage}
                name="image"
                alt="avatar"
                style={{ width: '100%' }}
              />
            ) : uploadButton}
        </Upload>
        <div className="text-left p-abs no-wrap ">
          <Text type="danger">{utils.upperCaseFirst(errors.pathImage || '')}</Text>
        </div>
      </Form.Item>
      <Form.Item label=" Thời gian" className="mb-large">
        <RangePicker
          showTime
          locale={consts.LangDateVi}
          format="DD-MM-YYYY HH:mm"
          onChange={onChangeDate}
        />
      </Form.Item>

      <Form.Item name="addTitle" label="Thêm ngôn ngữ">
        <div className="d-flex mb-small">
          <Input type="text" value={_currentTitle} onChange={addTabs} />
          <Button onClick={addTitle} disabled={!_currentTitle} className="mr-small">Thêm</Button>
        </div>
        <div className="text-left p-abs no-wrap ">
          <Text type="danger">{utils.upperCaseFirst(errorTitle || '')}</Text>
        </div>
      </Form.Item>
      <Form.Item name="titleContent" label="Ngôn ngữ" className="mb-large">
        <Tabs
          hideAdd
          onChange={setActiveKey}
          activeKey={_activeKey}
          type="editable-card"
          onEdit={onEditTitle}
        >
          {_panes.map((pane) => (
            <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
              <div className="mb-medium">
                <Input
                  placeholder="Tiêu đề"
                  type="text"
                  name={pane.title}
                  onChange={onChangeTitleContent}
                />
                <div className="text-left p-abs no-wrap">
                  <Text
                    type="danger"
                  >
                    {utils.upperCaseFirst(errors[`title.${pane.title}`] || '')}
                  </Text>
                </div>
              </div>
              <div>
                <TextArea
                  placeholder="Nội dung"
                  onChange={onChangeShortContent}
                  name={pane.title}
                  rows={4}
                />
                <div className="text-left p-abs no-wrap">
                  <Text
                    type="danger"
                  >
                    {utils.upperCaseFirst(errors[`shortContent.${pane.title}`] || '')}
                  </Text>
                </div>
              </div>
            </TabPane>
          ))}
        </Tabs>
      </Form.Item>

      <Form.Item label="Đường dẫn">
        <Input onChange={(e) => setLink(e.target.value)} name="link" value={_link} rows={4} />
        <div className="text-left p-abs no-wrap">
          <Text type="danger">{utils.upperCaseFirst(errors.link || '')}</Text>
        </div>
      </Form.Item>
    </Form>
  );

  const routeLuckyGameConfig = () => {
    history.push('/tool/campaign/lucky-game');
  };

  const isLuckyLink = (link) => link === '/lucky-wheel';

  return (
    <div className="p-medium">
      <div className="d-flex align-items pb-small space-between">
        <div className="mr-large">
          <span className="mr-small">Trạng thái</span>
          <Select defaultValue="-1" style={{ width: 120 }} onChange={onFilterStatus}>
            <Option value={ALL}>Tất cả</Option>
            <Option value={ACTIVE}>Hoạt Động</Option>
            <Option value={IN_ACTIVE}>Tạm dừng</Option>
          </Select>
        </div>
        <Button
          className="d-flex"
          onClick={showModalAdd}
        >
          <MdAddCircle size="20" className="styled-icon" />
          <span style={{ marginLeft: 4 }}> Thêm chiến dịch </span>
        </Button>
      </div>

      <div>
        <Table
          columns={columnsTable}
          dataSource={campaign}
          pagination={{
            current: _currentPage,
            onChange: (page, pageSize) => {
              fetchData((page - 1) * pageSize, pageSize);
              setCurrentPage(page);
              setLoading(true);
            },
            defaultPageSize: 10,
            total: _totalCount || 0,
            hideOnSinglePage: true,
          }}
          bordered
          loading={_loading}
        />
      </div>

      <Modal
        title={_isAddNew ? 'Thêm chiến dịch' : 'Sửa chiến dịch'}
        width="55%"
        visible={_visible}
        footer={_isAddNew
          ? [
            <Form.Item {...tailLayout} style={{ marginBottom: '12px' }} className="text-right">
              <Button
                onClick={handleCancel}
                style={{ width: '80px' }}
              >
                Hủy
              </Button>
              <DisplayControl permission_link_screen={[
                {
                  permission: consts.AUTH.CAMPAIGN,
                  action: consts.CONTROLS.POST,
                },
                {
                  permission: consts.AUTH.CAMPAIGN,
                  action: consts.CONTROLS.PUT,
                }]}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    marginLeft: 12,
                    width: '80px',
                  }}
                  icon={(
                    <Loadingsvg
                      name="bars"
                      hidden
                      size={25}
                    />
                  )}
                  onClick={onSubmit}
                >
                  Lưu
                </Button>
              </DisplayControl>
            </Form.Item>,
          ]
          : [
            <Form.Item {...tailLayout} style={{ marginBottom: '12px' }} className="text-right">
              <Button
                onClick={handleCancel}
                style={{ width: '80px' }}
              >
                Hủy
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  marginLeft: 12,
                  width: '80px',
                }}
                icon={(
                  <Loadingsvg
                    name="bars"
                    hidden={!isLoadingSave}
                    size={25}
                  />
                )}
                onClick={onSubmit}
              >
                Lưu
              </Button>
            </Form.Item>,
          ]}
        confirmLoading={isLoadingSave}
        onCancel={handleCancel}
      >
        {_isAddNew
          ? renderFormAdd()
          : renderFormEdit()}
        {
          isLuckyLink(_link) ? (
            <CenterWrapper>
              <Button
                onClick={routeLuckyGameConfig}
              >
                Cài đặt
              </Button>
            </CenterWrapper>
            )
            : <></>
        }
      </Modal>
    </div>
  );
}

Campaign.propTypes = {
  fetchAllCampaign: PropTypes.func,
  addCampaignAction: PropTypes.func,
  updateCampaignAction: PropTypes.func,
  deleteCampaignAction: PropTypes.func,
  campaign: PropTypes.array,
};

export default Campaign;
